<template>
  <div class="content">
    <div style="position: relative">
      <img alt="Vue logo" class="image_title" src="../assets/logo.png" />
      <div class="colorF text-left header">
        <div class="font-16">益清源</div>
        <div class="mt-1 font-20">水质监测数据云平台</div>
        <div class="rowAC">
          <div>
            <div class="font-smalll mt-1">
              探头编号:{{ info.SpectrometerID }}
            </div>
            <div class="font-smalll mt-1">设备编号:{{ info.PointID }}</div>
          </div>
          <div class="ml-5">
            <div class="font-smalll mt-1" v-if="info.PointName">
              设备名称:{{ info.PointName }}
            </div>
            <div class="font-smalll mt-1" v-if="info.projectName">
              项目名称:{{ info.projectName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Head",
  props: {
    msg: String,
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image_title {
  width: 100%;
  height: 135px;
  background-size: 100% 100%;
}

.header {
  position: absolute;
  top: 20%;
  left: 6%;
}
</style>
